export default '/src/assets/webgl/pedro_2/audios/en/bundle_1.mp3'